import React from "react";
import PropTypes from "prop-types";
import FormFieldGrid from "./FormFieldGrid";
import { TimePicker } from "@mui/x-date-pickers";
import { format, parse } from "date-fns";

function FormTimePicker(props) {
  return (
    <FormFieldGrid
      {...props}
      Field={TimePicker}
      fieldProps={({ value, onChange }) => {
        return {
          onChange: (value) => {
            onChange(value ? format(value, "HH:mm:ss") : null);
          },
          slotProps: {
            field: {
              clearable: true,
              onClear: () => {
                onChange(null);
              },
            },
          },
          ampm: false,
          views: ["hours", "minutes", "seconds"],
          value: value ? parse(value, "HH:mm:ss", new Date()) : null,
        };
      }}
    />
  );
}

FormTimePicker.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  textFieldType: PropTypes.string,
  timeFormat: PropTypes.string,
  dateFormat: PropTypes.string,
  outputFormat: PropTypes.string,
};

FormTimePicker.defaultProps = {
  textFieldType: "text",
  timeFormat: "HH:mm",
  outputFormat: "HH:mm:ss",
};

export default FormTimePicker;
